export type Operator = '=' | '<>' | '<' | '>' | '<=' | '>=' | 'LIKE' | 'IN' | 'NOT IN' | 'BETWEEN' | 'NOT BETWEEN' | 'IS NULL' | 'IS NOT NULL' | 'EXISTS' | 'NOT EXISTS';
export const OperationOptions: { id: string; name: string }[] = [
    { id: '=', name: '=' }, 
    { id: '<>', name: '<>' }, 
    { id: '<', name: '<' }, 
    { id: '>', name: '>' }, 
    { id: '<=', name: '<=' }, 
    { id: '>=', name: '>=' }, 
    { id: 'LIKE', name: 'LIKE' }, 
    { id: 'IN', name: 'IN' }, 
    { id: 'NOT IN', name: 'NOT IN' }, 
    { id: 'BETWEEN', name: 'BETWEEN' }, 
    { id: 'NOT BETWEEN', name: 'NOT BETWEEN' }, 
    { id: 'IS NULL', name: 'IS NULL' }, 
    { id: 'IS NOT NULL', name: 'IS NOT NULL' }, 
    { id: 'EXISTS', name: 'EXISTS' }, 
    { id: 'NOT EXISTS', name: 'NOT EXISTS' }
];
export type Align = 'Left' | 'Center' | 'Right';
export const alignOptions: { id: string; name: string }[] = [
    { id: 'Left', name: 'Left' },
    { id: 'Center', name: 'Center' },
    { id: 'Right', name: 'Right' }
]
export type FieldType = 'string' | 'number' | 'boolean' | 'date' | 'datetime' | 'time' | 'array' | 'picture' | 'file' | 'object' | 'json' | 'html' | 'markdown' | 'richtext' | 'currency' | 'percentage' | 'email' | 'url' | 'phone' | 'ip' | 'color';
export const fieldTypeOptions: { id: string; name: string }[] = [
    { id: 'string', name: 'String' },
    { id: 'number', name: 'Number' },
    { id: 'boolean', name: 'Boolean' },
    { id: 'date', name: 'Date' },
    { id: 'datetime', name: 'DateTime' },
    { id: 'time', name: 'Time' },
    { id: 'array', name: 'Array' },
    { id: 'picture', name: 'Picture' },
    { id: 'file', name: 'File' },
    { id: 'object', name: 'Object' },
    { id: 'json', name: 'JSON' },
    { id: 'html', name: 'HTML' },
    { id: 'markdown', name: 'Markdown' },
    { id: 'richtext', name: 'Rich Text' },
    { id: 'currency', name: 'Currency' },
    { id: 'percentage', name: 'Percentage' },
    { id: 'email', name: 'Email' },
    { id: 'url', name: 'URL' },
    { id: 'phone', name: 'Phone' },
    { id: 'ip', name: 'IP Address' },
    { id: 'color', name: 'Color' },
    { id: 'single-select', name: 'Single Select' },
    { id: 'multi-select', name: 'Multi Select' },
]
export type ConditionType = 'and' | 'or'
export const ConditionTypeOptions: { id: string; name: string }[] = [
    { id: 'and', name: 'and' }, 
    { id: 'or', name: 'or' }, 
]

export type MatchType = 'Value' | 'DB Field'
export const MatchTypeOptions: { id: string; name: string }[] = [
    { id: 'Value', name: 'Value' }, 
    { id: 'DB Field', name: 'DB Field' }, 
    { id: 'SQL Field', name: 'SQL Field' }, 
]

export type AggregateFunction = 'SUM' | 'COUNT' | 'AVG' | 'MIN' | 'MAX';
export const aggregateFunctionOptions: { id: string; name: string }[] = [
    { id: 'SUM', name: 'SUM' }, 
    { id: 'COUNT', name: 'COUNT' }, 
    { id: 'AVG', name: 'AVG' }, 
    { id: 'MIN', name: 'MIN' }, 
    { id: 'MAX', name: 'MAX' }, 
]

export type PageSize = 'A4' | 'A3' | 'Letter' | 'Legal' | 'Tabloid' | 'Custom';
export const PageSizeOptions: { id: string; name: string }[] = [
    { id: 'A4', name: 'A4' }, 
    { id: 'A3', name: 'A3' }, 
    { id: 'Letter', name: 'Letter' }, 
    { id: 'Legal', name: 'Legal' }, 
    { id: 'Tabloid', name: 'Tabloid' }, 
    { id: 'Custom', name: 'Custom' }, 
];

export type Orientation = 'Portrait' | 'Landscape';
export const OrientationOptions: { id: string; name: string }[] = [
    { id: 'Portrait', name: 'Portrait' }, 
    { id: 'Landscape', name: 'Landscape' }, 
];

export type JoinType = 'INNER JOIN' | 'LEFT JOIN' | 'RIGHT JOIN' | 'CROSS JOIN';
export const JoinTypeOptions: { id: string; name: string }[] = [
    { id: 'INNER JOIN', name: 'INNER JOIN' }, 
    { id: 'LEFT JOIN', name: 'LEFT JOIN' }, 
    { id: 'RIGHT JOIN', name: 'RIGHT JOIN' }, 
    { id: 'CROSS JOIN', name: 'CROSS JOIN' }, 
];

export const fontOptions: { id: string; name: string }[] = [
    { id: 'Arial', name: 'Arial' }, 
    { id: 'Times New Roman', name: 'Times New Roman' }, 
];

export const inputTypeOptions: { id: string; name: string }[] = [
    { id: 'TextInput', name: 'TextInput' },
    { id: 'NumberInput', name: 'NumberInput' },
    { id: 'CheckInput', name: 'CheckInput' },
    { id: 'DateCalendarInput', name: 'DateCalendarInput' },
    { id: 'DateTimeCalendarInput', name: 'DateTimeCalendarInput' },
    { id: 'TimePickerInput', name: 'TimePickerInput' },    
    { id: 'SingleDropDownInput', name: 'SingleDropDownInput' },
    { id: 'MultiDropDownInput', name: 'MultiDropDownInput' }
]

export interface Table {
    id: string; // Unique identifier for the table
    name: string; // Name of the table
    displayName: string; // Display name for the table
    alias: string; // Alias for the table
    fields: Field[]; // Fields associated with the table
    baseTable?: boolean
    sourceTableId?: string;
    sourceTableName?: string;
    sourceTableAlias?: string;
    sourceField?: string;
    joinType?: JoinType;
    targetTableId?: string;
    targetTableName?: string;
    targetTableAlias?: string;
    targetField?: string;
    joins?: Join[];
    conditions?: Condition[];
    raw: boolean; // Whether the table is a raw SQL table
    rawQuery?: string; // SQL query for raw tables
}
export interface Field {
    id: string; // Unique identifier for the sort
    tableId: string;
    tableName: string;
    tableAlias: string;
    name: string;
    alias: string;
    caption: string;
    visible: boolean;
    sort_order?: number; // Optional: Sort order for the field
    aggregateFunction?: AggregateFunction; // Optional: Aggregation function for the field
    decimals?: number; // Optional: Number of decimal places for numeric fields
    sqlQuery?: string; // Optional: SQL query for the field
    align: Align;
    type: FieldType;
    width?: number;
    raw?: boolean; // Optional: Whether the field is raw (not formatted)
    rawQuery?: string; // Optional: Raw query for the field
    manual?: boolean; // Optional: Whether the field is manually added
    ignoreGroup?: boolean; // Optional: Whether to ignore the field in grouping
}
export interface Condition {
    id: string | number; // Unique identifier for the sort
    type?: ConditionType;
    tableId: string;
    tableName: string;
    tableAlias: string;
    tableFields?: Field[];
    fieldName: string;
    operator?: Operator;
    matchType: MatchType;
    dbTableId?: string;
    dbTable?: string;
    dbTableAlias?: string;
    dbField?: string;
    dbTableFields?: Field[];
    value?: string;
    group?: boolean;
    childConditions?: Condition[];
}
export interface Join {
    id: string | number; // Unique identifier for the sort
    joinType: 'INNER JOIN'| 'LEF JOIN' | 'RIGHT JOIN'| 'CROSS JOIN';
    joinTypeError?: string;
    sourceTableId: string;
    sourceTableName: string;
    sourceTableAlias: string;
    sourceField: string;
    sourceFieldError?: string;
    operator: Operator;
    targetTableId: string;
    targetTableName: string;
    targetTableAlias: string;
    targetTableError?: string;
    targetField: string;
    targetFieldError?: string;
    childJoins?: Join[];
    targetTableFields?: Field[];
    conditions: Condition[];
}
export interface Filter {
    id: string | number; // Unique identifier for the sort
    table: string;
    tableAlias: string;
    fieldName: string;
    caption: string;
    operator: Operator;
    matchType: MatchType;
    dbTable?: string;
    dbTableAlias?: string;
    dbNameField?: string;
    dbIdField?: string;
    required: boolean;
    raw?: boolean; // Optional: Whether the field is raw (not formatted)
    rawQuery?: string; // Optional: Raw query for the field
    sqlQuery?: string; // Optional: SQL query for the field
    value: string | number | boolean | Date | null | string[] | number[] | boolean[] | Date[];
    error?: string; // Optional: Error message for the filter
    group?: boolean;
    condition: string;
    inputType: string
    childFilters?: Filter[];
    hidden?: boolean; // Optional: Whether the filter is hidden
}
export interface Sort {
    id: string | number; // Unique identifier for the sort
    field: Field;
    order: 'asc' | 'desc';
}
export interface Pivot {
    pivotFieldId?: string;
    aggregateFieldId?: string;
    aggregateFunction?: string; // The aggregation function to apply
    width?: number; // Optional: Width of the pivot field
    fields: Field[]; // Fields to include in the pivot
    dynamicFields?: boolean; // Whether to allow dynamic fields in the pivot
    dbTable?: string; // Optional: Database table for the pivot
    dbField?: string; // Optional: Database field for the pivot
    sortField?: string
    sortOrder?: 'asc' | 'desc'; // Optional: Sorting for the pivot
}
export interface PageSetting {
    pageSize: PageSize;
    topMargin: number; // in mm
    bottomMargin: number; // in mm
    leftMargin: number; // in mm
    rightMargin: number; // in mm
    footerMargin: number; // in mm
    headerMargin: number; // in mm
    orientation: Orientation;
    fontSize: number; // in points
    fontFamily: string; // e.g., 'Arial', 'Times New Roman'
}
export interface ReportDesign {
    id: string;
    name: string;
    description: string;
    type: string;
    pageSettings: PageSetting
    tables: Table[];
    baseTable: string;
    baseTableAlias: string;
    fields: Field[];
    joins: Join[];
    filters: Filter[];
    groups: string[];
    sorts: Sort[];
    pivot?: Pivot | null;
    modules: [],
    accessGroups: [],
    rawReport?: boolean;
    rawQuery?: string;
}